angular
    .module("fondiBei.components", [])
    .component("fondiBei", {
        templateUrl: "ng/components/fondiBei/fondiBei.view.html",
        controllerAs: "FondiBeiCtrl",
        bindings: {
            exportValidityQuestionario: "&",
            exportModelQuestionario: "&",
            exportButtonConfirmIsVisible: "&",
            portal: "=",
            leasingData: "=",
            financialCustomer: "=",
            snapshot: '<',
            portalRunned: '<',
            cessioneVoltura: "="
        },
        controller: FondiBeiController
    })

function FondiBeiController(
    $notificationService,
    $location,
    $portalService,
    QuestionarioBei,
    $uniService,
    $rootScope,
    $modalService,
    $scope
) {
    var self = this;

    self.$onInit = function () {
        callRestForAteco();
        $scope.forms = {};
        self.$portalService = $portalService;
        self.controlShowOtherInput = [];
        self.showHr = [];
        self.questBei12 = [];
        self.supportModel = {
            codiceIdentificativo: "",
            partitaIva: "",
            ndg: "",
            dataUltimaModifica: "",
            statoQuestionario: "",
            societaRichiedente: "",
            indirizzo: "",
            codiceFiscale: "",
            anno: "",
            preventivo: "",
            impresa: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.rb1 : undefined,
            impresaAutonoma: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.rb2 : undefined,
            impresaAssociata: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.rb3 : undefined,
            impresaCollegata: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.rb4 : undefined,
            numeroDipendenti: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.numDipendenti : 0,
            codiceAteco: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.destinatario.ateco : "",
            periodoRiferimento: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.periodo : "",
            settoriEsclusi: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.rb5 : undefined,
            progettoEligible: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.rb6 : undefined,
            importo: undefined,
            quotaImportoGreen: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.quotaImportoGreen : undefined,
            dropdown: {
                macroSettore: [],
                settore: [],
                categoriaSottoProgetto: [],
                ateco: []
            },
            macroSettore: {
                value: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.macroSettore : ""
            },
            settore: {
                value: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.settore : ""
            },
            categoriaSottoProgetto: {
                value: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.categoriaSottoprogetto : ""
            },
            valoreIndicatore: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.valoreIndicato : "",
            descrizioneProgetto: self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.descrizione : "",
            statoQuestionario: "",
            labelQuestionarioDaCorreggere: "",
            questionarioDaCorreggere: false,
            preventivo: "",
            anno: "",
            indirizzoCompleto: "",
            comune: "",
            provincia: "",
            cap: "",
            stato: "",
            convenzione: "",
            numeroDipendentiMax: undefined,
            numeroDipendentiMin: undefined,
            contratto: undefined,
            modulo: undefined,
            tipoModulo: "",
            internal: false,
            emailCli: "",
            numModulo: undefined
        }

        self.nextStepEnabled = false;
        self.isVisibleInfoOpzioneGreen = self.portal === "BEI_POSTVENDITA" ? self.cessioneVoltura.questionarioBei.rb6 : false;
        self.buttonEnabled = false;
        self.loader = false;
        self.settoreSelectIsEnabled = false;
        self.cateogoriaSottoProgettoSelectIsEnabled = false;
        self.codiceMacroSettore = undefined;
        self.codiceSettore = undefined;
        self.codiceCategoriaSottoProgetto = undefined;
        self.nextPressed = false;
        self.labelMessageOk = "";
        if (self.portal === 'BEI_DIGITAL') {
            self.supportModel.codiceIdentificativo = self.leasingData.preventivo.anno +
                self.leasingData.preventivo.numero
            self.supportModel.partitaIva = self.financialCustomer.metadata.riUserG.piva;

            self.onPressSearch();
        } else if (self.portal === 'BEI_POSTVENDITA') {
            $notificationService.getCascadingDropDown("BEI11")
                .then(function (response) {
                    self.supportModel.dropdown.macroSettore = response;
                })
        }
    }

    self.handleChange = function (property, value) {

        if (property == 'quotaImportoGreen') {
            self.supportModel[property] = value;
        }

        if (property == 'partitaIva' || property == 'codiceIdentificativo') {
            self.supportModel[property] = value;
        }

        if (property === 'impresaAutonoma') {
            if (self.supportModel.impresaAutonoma) {
                self.supportModel.impresaAssociata = false;
                self.supportModel.impresaCollegata = false;
            }
        }

        if (property === 'impresaAssociata') {
            if (self.supportModel.impresaAssociata) {
                self.supportModel.impresaAutonoma = false;
                self.supportModel.impresaCollegata = false;
            }
        }

        if (property === 'impresaCollegata') {
            if (self.supportModel.impresaCollegata) {
                self.supportModel.impresaAutonoma = false;
                self.supportModel.impresaAssociata = false;
            }
        }

        if (property === 'progettoEligible') {
            if (self.supportModel.progettoEligible) {
                self.isVisibleInfoOpzioneGreen = true;
            } else {
                self.isVisibleInfoOpzioneGreen = false;
            }
        }

        if (property === 'macroSettore') {
            self.settoreSelectIsEnabled = false;
            self.cateogoriaSottoProgettoSelectIsEnabled = false;
            self.supportModel.settore.value = "",
                self.supportModel.categoriaSottoProgetto.value = "",
                self.descrizioneLevel3CategoriaSottoProgetto = "";
            self.codiceLevel4CategoriaSottoProgetto = "";
            self.codiceMacroSettore = value;
        }

        if (property === 'settore') {
            self.codiceSettore = value;
        }

        if (property === 'macroSettore' ||
            property === 'settore') {
            if (self.supportModel.macroSettore.value &&
                self.supportModel.settore.value) {
                $notificationService.getCascadingDropDown("BEI11", self.codiceMacroSettore, self.codiceSettore)
                    .then(function (response) {
                        self.supportModel.dropdown.categoriaSottoProgetto = response;
                    })
                self.cateogoriaSottoProgettoSelectIsEnabled = true;
            } else if (self.supportModel.macroSettore.value) {
                $notificationService.getCascadingDropDown("BEI11", self.codiceMacroSettore)
                    .then(function (response) {

                        self.supportModel.dropdown.settore = response;
                    })

                self.settoreSelectIsEnabled = true;
            }
        }

        if (property === 'categoriaSottoProgetto') {
            self.supportModel.categoriaSottoProgetto.value = value;
            self.codiceCategoriaSottoProgetto = value.codLevel3;
            self.descrizioneLevel3CategoriaSottoProgetto = value.descrLevel3;
            self.codiceLevel4CategoriaSottoProgetto = value.codLevel4;
        }

        if (property === 'valoreIndicatore') {
            self.supportModel.valoreIndicatore = value;
        }

        self.checkQuestionarioDaCorreggere();

        if (!self.supportModel.progettoEligible) {
            self.supportModel.macroSettore.value = undefined;
            self.supportModel.settore.value = undefined;
            self.supportModel.categoriaSottoProgetto.value = undefined;
            self.supportModel.descrizioneProgetto = undefined;
        }

        var model = self.dataModel();

        self.exportModelQuestionario({
            model: model
        })

        self.checkValidity();
    }

    self.onPressSearch = function () {

        var codiceIndentificativo = self.supportModel.codiceIdentificativo;
        var partitaIva = self.supportModel.partitaIva;

        if (!codiceIndentificativo && !partitaIva) {
            //non faccio partire la chiamata se uno dei due campi in input è vuoto
            return
        }

        self.loader = true;
        $notificationService.getExtNotificationDataById(
            codiceIndentificativo,
            partitaIva
        )
            .then(function (response) {
                if (response.success) {
                    if (self.leasingData && self.leasingData.preventivo) {
                        self.leasingData.preventivo.questionarioBei = QuestionarioBei.build(response);
                    }
                    self.questBei12 = [];
                    // TODO da sistemare questo schifo creato da Daniele
                    self.supportModel.ndg = response.ndg;
                    self.supportModel.dataUltimaModifica = response.dataUltimaModifica;
                    self.supportModel.societaRichiedente = response.ragSoc
                    self.supportModel.indirizzo = response.indirizzo;
                    self.supportModel.numero = response.preventivo;
                    self.supportModel.impresa = response.rb1;
                    self.supportModel.impresaAutonoma = response.rb2;
                    self.supportModel.impresaAssociata = response.rb3;
                    self.supportModel.impresaCollegata = response.rb4;
                    self.supportModel.numeroDipendenti = response.numDipendenti;
                    self.supportModel.codiceAteco = response.ateco;
                    self.supportModel.periodoRiferimento = response.periodo;
                    self.supportModel.settoriEsclusi = response.rb5;
                    self.supportModel.progettoEligible = response.rb6;
                    self.supportModel.macroSettore.value = response.macroSettore;
                    self.supportModel.importo = response.importo;
                    self.supportModel.quotaImportoGreen = response.quotaImportoGreen;
                    self.supportModel.valoreIndicatore = response.valoreIndicato;
                    self.supportModel.descrizioneProgetto = response.descrizione;
                    self.supportModel.preventivo = response.preventivo;
                    self.supportModel.anno = response.anno;
                    self.supportModel.indirizzoCompleto = response.indirizzoCompleto;
                    self.supportModel.comune = response.comune;
                    self.supportModel.provincia = response.provincia;
                    self.supportModel.cap = response.cap;
                    self.supportModel.stato = response.stato;
                    self.supportModel.convenzione = response.convenzione;
                    self.supportModel.codiceFiscale = response.cf;
                    self.supportModel.functionId = response.functionId;
                    self.supportModel.cdPrd = response.cdPrd;
                    self.supportModel.agevolazione1 = response.agevolazione1;
                    self.supportModel.agevolazione2 = response.agevolazione2;
                    self.supportModel.numeroContratto = response.numeroContratto;
                    self.supportModel.modulo = response.modulo;
                    self.supportModel.tipoModulo = response.tipoModulo;
                    self.supportModel.internal = response.internal;
                    self.supportModel.extended = response.extended;

                    if (!!self.supportModel.numeroContratto && !!self.supportModel.modulo) {
                        self.supportModel.isEditableInAra = true;
                    } else {
                        self.supportModel.isEditableInAra = false;
                    }

                    switch (response.status) {
                        case 'CREATED':
                            self.supportModel.statoQuestionario = "LBL_QUESTION_CREATED"
                            break;
                        case 'CONFIRMED':
                            self.supportModel.statoQuestionario = "LBL_QUESTION_CONFIRMED"
                            break;
                        case 'CORRECTION':
                            self.supportModel.statoQuestionario = "LBL_QUESTION_CORRECTION"
                            break;
                        case 'CORRECTED':
                            self.supportModel.statoQuestionario = "LBL_QUESTION_CORRECTED"
                            break;
                        case 'VALIDATED':
                            self.supportModel.statoQuestionario = "LBL_QUESTION_VALIDATED"
                            break;
                        default:
                            break;
                    }

                    switch (response.convenzione) {
                        case 'HO1':
                        case 'H95':
                        case 'IE4':
                        case 'IX1':
                        case 'LG4':
                            self.regex = "numericFondiBeiHO1"
                            break;
                        case 'HO0':
                        case 'H94':
                        case 'IE3':
                        case 'IX0':
                        case 'LG3':
                            self.regex = "numericFondiBeiHO0"
                            break;
                        default:
                            self.regex = "numericFondiBeiDefault";
                            break;
                    }

                    if (response.rb1 === null) {
                        self.supportModel.impresa = true;
                    }

                    if (response.rb6) {
                        self.isVisibleInfoOpzioneGreen = true;
                    } else {
                        self.isVisibleInfoOpzioneGreen = false;
                    }

                    if (response.settore) {
                        self.supportModel.settore.value = response.settore;
                    }

                    if (response.categoriaSottoprogetto) {
                        self.supportModel.categoriaSottoProgetto.value = response.categoriaSottoprogetto;
                    }

                    if (response.hideGreen) {
                        self.hiddenGreenSection = true;
                        response.green = false;
                        self.supportModel.progettoEligible = false;
                        self.questionario = response.questionario
                        if (self.questionario && self.supportModel.extended) {
                            self.validQuestBei12 = false;
                            createModelForQuestion();
                        } else {

                            self.validQuestBei12 = true;
                        }
                    } else {
                        self.validQuestBei12 = true;
                        self.hiddenGreenSection = false;
                    }


                    if (response.green) {
                        self.supportModel.progettoEligible = true;
                        self.lockRadioProgettoEligibile = true;
                        self.handleChange('progettoEligible')
                    }

                    self.loader = false;
                    self.isVisibleQuestionarioBeiOpzioneGreen = true;

                    self.exportButtonConfirmIsVisible({
                        value: true
                    })

                    self.checkQuestionarioDaCorreggere();

                    var model = self.dataModel();

                    self.exportModelQuestionario({
                        model: model
                    })

                    self.checkValidity();
                } else {
                    self.exportButtonConfirmIsVisible({
                        value: false
                    })
                    self.loader = false;
                }
            })
            .catch(function () {
                self.loader = false;
            })


        $notificationService.getCascadingDropDown("BEI11")
            .then(function (response) {
                self.supportModel.dropdown.macroSettore = response;
            })
    }

    self.checkValidity = function () {
        console.log("Form: ", $scope.questionarioBeiForm);
        if ($portalService.isAra() && self.supportModel.questionarioDaCorreggere) {
            self.exportValidityQuestionario({
                validity: true
            })
            return true;
        }
        var checkIfOtherField = ((self.showInputField && !!self.supportModel.quotaImportoGreen) ||
            (self.showSelectField && !!self.supportModel.valoreIndicatore)) ||
            (!self.showInputField && !self.showSelectField)
        if (!self.supportModel.progettoEligible) {
            if (self.supportModel.impresa &&
                self.supportModel.impresaAutonoma !== undefined &&
                self.supportModel.impresaAutonoma !== null &&
                self.supportModel.impresaAssociata !== undefined &&
                self.supportModel.impresaAssociata !== null &&
                self.supportModel.impresaCollegata !== undefined &&
                self.supportModel.impresaCollegata !== null &&
                self.supportModel.numeroDipendenti &&
                self.supportModel.codiceAteco &&
                self.supportModel.periodoRiferimento &&
                self.supportModel.settoriEsclusi == false &&
                self.supportModel.progettoEligible !== undefined &&
                self.supportModel.progettoEligible !== null &&
                self.validQuestBei12 &&
                checkIfOtherField
            ) {
                self.exportValidityQuestionario({
                    validity: true
                })
                return true;
            } else {
                self.exportValidityQuestionario({
                    validity: false
                })
                return false;
            }
        } else {
            if (self.supportModel.impresa &&
                self.supportModel.impresaAutonoma !== undefined &&
                self.supportModel.impresaAutonoma !== null &&
                self.supportModel.impresaAssociata !== undefined &&
                self.supportModel.impresaAssociata !== null &&
                self.supportModel.impresaCollegata !== undefined &&
                self.supportModel.impresaCollegata !== null &&
                self.supportModel.numeroDipendenti &&
                self.supportModel.codiceAteco &&
                self.supportModel.periodoRiferimento &&
                self.supportModel.settoriEsclusi == false &&
                self.supportModel.quotaImportoGreen &&
                self.supportModel.quotaImportoGreen <= self.supportModel.importo &&
                self.supportModel.macroSettore.value &&
                self.supportModel.settore.value &&
                self.supportModel.categoriaSottoProgetto.value &&
                self.supportModel.valoreIndicatore &&
                self.supportModel.descrizioneProgetto) {
                self.exportValidityQuestionario({
                    validity: true
                })
                return true;
            } else {
                self.exportValidityQuestionario({
                    validity: false
                })
                return false;
            }
        }
    }

    self.checkQuestionarioDaCorreggere = function () {
        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_CREATED') {
            if (self.supportModel.questionarioDaCorreggere) {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_CREATED_YES";
            } else {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_CREATED_NO";
            }
        }

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_CONFIRMED') {
            if (self.supportModel.questionarioDaCorreggere) {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_BEI_YES";
            } else {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_BEI_CONFIRMED_VALIDATED_NO";
            }
        }

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_CORRECTION') {
            if (self.supportModel.questionarioDaCorreggere) {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_BEI_YES";
            } else {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_BEI_CORRECTION_CORRECTED_NO";
            }
        }

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_CORRECTED') {
            if (self.supportModel.questionarioDaCorreggere) {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_BEI_YES";
            } else {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_BEI_CORRECTION_CORRECTED_NO";
            }
        }

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_VALIDATED') {
            if (self.supportModel.questionarioDaCorreggere) {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_BEI_YES";
            } else {
                self.supportModel.labelQuestionarioDaCorreggere = "LBL_STATUS_QUESTIONARIO_BEI_CONFIRMED_VALIDATED_NO";
            }
        }
    }

    self.dataModel = function () {
        self.model = {
            id: self.supportModel.codiceIdentificativo,
            partitaIva: self.supportModel.partitaIva,
            ndg: self.supportModel.ndg,
            societaRichiedente: self.supportModel.societaRichiedente,
            indirizzo: self.supportModel.indirizzo,
            codiceFiscale: self.supportModel.codiceFiscale,
            rb1: self.supportModel.impresa,
            rb2: self.supportModel.impresaAutonoma,
            rb3: self.supportModel.impresaAssociata,
            rb4: self.supportModel.impresaCollegata,
            numDipendenti: self.supportModel.numeroDipendenti,
            codiceAteco: self.supportModel.codiceAteco,
            periodo: self.supportModel.periodoRiferimento,
            rb5: self.supportModel.settoriEsclusi,
            rb6: self.supportModel.progettoEligible,
            importo: self.supportModel.importo,
            quotaImportoGreen: self.supportModel.quotaImportoGreen,
            macroSettore: self.supportModel.macroSettore.value,
            settore: self.supportModel.settore.value,
            categoriaSottoprogetto: self.supportModel.categoriaSottoProgetto.value,
            valoreIndicatore: self.supportModel.valoreIndicatore,
            descrizione: self.supportModel.descrizioneProgetto,
            preventivo: self.supportModel.preventivo,
            anno: self.supportModel.anno,
            indirizzoCompleto: self.supportModel.indirizzoCompleto,
            comune: self.supportModel.comune,
            provincia: self.supportModel.provincia,
            cap: self.supportModel.cap,
            stato: self.supportModel.stato,
            convenzione: self.supportModel.convenzione,
            questionario: self.questionario,
            functionId: self.supportModel.functionId,
            cdPrd: self.supportModel.cdPrd,
            agevolazione1: self.supportModel.agevolazione1,
            agevolazione2: self.supportModel.agevolazione2,
            numeroContratto: self.supportModel.numeroContratto,
            modulo: self.supportModel.modulo,
            tipoModulo: self.supportModel.tipoModulo,
            internal: self.supportModel.internal,
            emailCli: self.supportModel.emailCli
        }

        return self.model;
    }

    self.submitBei = function () {
        $notificationService.submitQuestBei(
            self.supportModel.codiceIdentificativo,
            self.supportModel.functionId,
            self.supportModel.ndg,
            self.supportModel.societaRichiedente,
            self.supportModel.indirizzo,
            self.supportModel.codiceFiscale,
            self.supportModel.partitaIva,
            self.supportModel.impresa,
            self.supportModel.impresaAutonoma,
            self.supportModel.impresaAssociata,
            self.supportModel.impresaCollegata,
            self.supportModel.numeroDipendenti,
            self.supportModel.codiceAteco,
            self.supportModel.settoriEsclusi,
            self.supportModel.periodoRiferimento,
            self.supportModel.progettoEligible,
            self.supportModel.importo,
            self.supportModel.quotaImportoGreen,
            self.supportModel.macroSettore.value,
            self.supportModel.settore.value,
            self.supportModel.categoriaSottoProgetto.value,
            self.supportModel.valoreIndicatore,
            self.supportModel.descrizioneProgetto,
            self.supportModel.preventivo,
            self.supportModel.anno,
            self.supportModel.indirizzoCompleto,
            self.supportModel.comune,
            self.supportModel.provincia,
            self.supportModel.cap,
            self.supportModel.stato,
            self.supportModel.convenzione,
            self.supportModel.questionarioDaCorreggere,
            null,
            self.questionario,
            self.supportModel.cdPrd,
            self.supportModel.agevolazione1,
            self.supportModel.agevolazione2,
            self.supportModel.numeroContratto,
            self.supportModel.modulo,
            self.supportModel.tipoModulo,
            self.supportModel.internal,
            self.supportModel.emailCli

        )
            .then(function (response) {
                if (response.filename) {
                    self.enabledLoader = false;
                    self.nextPressed = true;
                    self.nextClicked();
                }
                self.enabledLoader = false;
            })
            .catch(function () {
                self.enabledLoader = false;
                self.nextPressed = false;
            })

    }

    self.updateBei = function () {
        $notificationService.updateQuestBeiStatus(
            self.supportModel.codiceIdentificativo,
            self.supportModel.functionId,
            self.supportModel.ndg,
            self.supportModel.societaRichiedente,
            self.supportModel.indirizzo,
            self.supportModel.codiceFiscale,
            self.supportModel.partitaIva,
            self.supportModel.impresa,
            self.supportModel.impresaAutonoma,
            self.supportModel.impresaAssociata,
            self.supportModel.impresaCollegata,
            self.supportModel.numeroDipendenti,
            self.supportModel.codiceAteco,
            self.supportModel.settoriEsclusi,
            self.supportModel.periodoRiferimento,
            self.supportModel.progettoEligible,
            self.supportModel.importo,
            self.supportModel.quotaImportoGreen,
            self.supportModel.macroSettore.value,
            self.supportModel.settore.value,
            self.supportModel.categoriaSottoProgetto.value,
            self.supportModel.valoreIndicatore,
            self.supportModel.descrizioneProgetto,
            self.supportModel.preventivo,
            self.supportModel.anno,
            self.supportModel.indirizzoCompleto,
            self.supportModel.comune,
            self.supportModel.provincia,
            self.supportModel.cap,
            self.supportModel.stato,
            self.supportModel.convenzione,
            self.supportModel.questionarioDaCorreggere,
            null,
            self.questionario,
            self.supportModel.cdPrd,
            self.supportModel.agevolazione1,
            self.supportModel.agevolazione2,
            self.supportModel.numeroContratto,
            self.supportModel.modulo,
            self.supportModel.tipoModulo,
            self.supportModel.internal,
            self.supportModel.emailCli

        )
            .then(function () {
                self.enabledLoader = false;
                self.nextPressed = true;
                self.nextClicked();
            })
            .catch(function () {
                self.enabledLoader = false;
                self.nextPressed = false;
            })
    }

    self.nextClicked = function () {
        if (self.supportModel.questionarioDaCorreggere) {
            self.labelMessageOk = "LBL_QUESTION_AVAILABLE_CORRECTION";
        } else {
            self.labelMessageOk = "LBL_QUESTION_CORRECT_STORED";
        }
    }

    self.next = function () {
        self.enabledLoader = true;

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_CREATED') {
            if (!self.supportModel.questionarioDaCorreggere) {
                self.submitBei();
            } else {
                $location.path('/');
            }
        }

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_CONFIRMED') {
            if (self.supportModel.questionarioDaCorreggere) {
                self.updateBei();
            } else {
                $location.path('/');
            }
        }

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_CORRECTION') {
            if (self.supportModel.questionarioDaCorreggere) {
                self.updateBei();
            } else {
                self.submitBei();
            }
        }

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_CORRECTED') {
            self.updateBei();
        }

        if (self.supportModel.statoQuestionario === 'LBL_QUESTION_VALIDATED') {
            if (self.supportModel.questionarioDaCorreggere) {
                self.updateBei();
            } else {
                $location.path('/');
            }
        }
    }

    var createModelForQuestion = function () {
        if (self.questBei12.length == 0) {
            self.questBei12.push(self.questionario.question)

            if (self.questionario.question.value) {
                // questionario già compilato provvedo a recuperare le info dal modello
                popolateQuestBei11(self.questionario.question);
            }
        }

    }

    self.radioSelected = function (quest, idRisposta, index, id) {
        // var id = quest.findIndex(function (element) {
        //     return element.id == idRisposta;
        // })

        if (index < self.questBei12.length - 1) {
            var numberOfElementDeleted = (self.questBei12.length - 1) - index;
            for (var i = 0; i < numberOfElementDeleted; i++) {
                if (self.questBei12[self.questBei12.length - 1] && self.questBei12[self.questBei12.length - 1].value) {
                    self.questBei12[self.questBei12.length - 1].value = null;
                }
                self.questBei12.pop();
            }
        }
        quest.forEach(function (element, index) {
            if (id == index) {
                element.selected = true;
            } else {
                element.selected = false;
            }
        })
        // sezione controllo visualizzazione campi aggiuntivi
        self.controlShowOtherInput = [];
        self.questBei12.forEach(x => {
            x.answers.forEach(y => {
                if (y.selected) {
                    self.controlShowOtherInput.push(y)
                }
            })
        })

        self.showInputField = self.controlShowOtherInput.some(x => {
            return x.relShowId === 'amount_innovazione_bei13'
        })
        self.showSelectField = self.controlShowOtherInput.some(x => {
            return x.relShowId === 'ateco_innovazione_bei13'
        })

        if (!self.showInputField) {
            self.supportModel.quotaImportoGreen = null;
        }

        if (!self.showSelectField) {
            self.supportModel.valoreIndicatore = null;
        }

        // fine sezione visualizzazione campi aggiuntivi

        if (quest[id].outcome) {
            self.questBei12.push(quest[id].outcome)
            if (quest[id].outcome.type == "positive") {
                self.validQuestBei12 = true;
            } else {
                self.validQuestBei12 = false;
            }
            if (index > 0) {
                self.showHr[index] = false;
            }

        } else {
            self.questBei12.push(quest[id].question);
            self.validQuestBei12 = false;
            self.showHr[index] = true;
        }
        var model = self.dataModel();

        self.exportModelQuestionario({
            model: model
        })
        self.checkValidity();

    }

    var popolateQuestBei11 = function (question) {
        if (question && question.answers) {
            var temp = question.answers.find(function (element) {
                return element.selected == true;
            })
            self.questBei12.push(temp.question)
            popolateQuestBei11(temp.question)
        } else {
            self.validQuestBei12 = true;
            var model = self.dataModel();

            self.exportModelQuestionario({
                model: model
            })
            self.controlShowOtherInput = [];
            self.questBei12.forEach(x => {
                x && x.answers.forEach(y => {
                    if (y.selected) {
                        self.controlShowOtherInput.push(y)
                    }
                })
            })

            self.showInputField = self.controlShowOtherInput.some(x => {
                return x.relShowId === 'amount_innovazione_bei13'
            })
            self.showSelectField = self.controlShowOtherInput.some(x => {
                return x.relShowId === 'ateco_innovazione_bei13'
            })
            self.checkValidity();
            functionShowHr();
            return;
        }
    };

    var functionShowHr = function () {
        self.questBei12.forEach(function (element, index) {
            if (index < self.questBei12.length - 2) {
                self.showHr[index] = true;
            }
        })
    }

    self.sendToClient = function (internal) {
        if (internal) {
            self.loaderSendToClientNoSend = true;
            $uniService.sendBeiCtr(self.supportModel.contratto, self.supportModel.numModulo, internal)
                .then(function (response) {
                    if (response.success) {
                        $rootScope.$broadcast("addAlert", {
                            text: "SEND_QUEST_BEI_TO_CLIENT_OK",
                        });
                        if (internal) {
                            self.supportModel.partitaIva = response.piva;
                            self.supportModel.codiceIdentificativo = response.id
                        }
                    }
                    if (internal) {
                        self.loaderSendToClientNoSend = false;
                    } else {
                        self.loaderSendToClient = false;
                    }
                    self.supportModel.contratto = undefined;
                    self.supportModel.numModulo = undefined;
                })
                .catch(function (error) {
                    $rootScope.$broadcast("addAlert", {
                        text: "LBL_QBEI_UNEXPECTED",
                    });
                    if (internal) {
                        self.loaderSendToClientNoSend = false;
                    } else {
                        self.loaderSendToClient = false;
                    }
                    self.supportModel.contratto = undefined;
                    self.supportModel.numModulo = undefined;
                })
        } else {
            self.loaderSendToClient = true;

            $uniService.getEmailCliForBei(self.supportModel.contratto, self.supportModel.numModulo)
                .then(function (response) {
                    if (response.success) {
                        self.supportModel.emailCli = response.emailCli;
                        $modalService.openModal("mailCliBEI-modal")
                    }

                    self.loaderSendToClient = false;
                })
                .catch(function (error) {
                    $rootScope.$broadcast("addAlert", {
                        text: "LBL_QBEI_UNEXPECTED",
                    });

                    self.loaderSendToClient = false;

                    self.supportModel.contratto = undefined;
                    self.supportModel.numModulo = undefined;
                })
        }
    }

    self.closeModal = function () {
        $modalService.closeModal("mailCliBEI-modal")
    }

    self.confirmModal = function () {
        self.loaderModal = true;
        $uniService.sendBeiCtr(self.supportModel.contratto, self.supportModel.numModulo, false, self.supportModel.emailCli)
            .then(function (response) {
                if (response.success) {
                    $rootScope.$broadcast("addAlert", {
                        text: "SEND_QUEST_BEI_TO_CLIENT_OK",
                    });
                    $modalService.closeModal("mailCliBEI-modal")
                }
                self.loaderModal = false;
                self.supportModel.contratto = undefined;
                self.supportModel.numModulo = undefined;
            })
            .catch(function (error) {
                $rootScope.$broadcast("addAlert", {
                    text: "LBL_QBEI_UNEXPECTED",
                });
                self.loaderModal = false;
                self.supportModel.contratto = undefined;
                self.supportModel.numModulo = undefined;
            })

    }

    var callRestForAteco = function () {
        $uniService.getAtecoInnovativi()
            .then(function (response) {
                self.supportModel.dropdown.ateco = response.domainList;
            })
    }
}
